export function Section({
    icon,
    title,
    headerSlot = null,
    bodyClassName = '',
    children,
}: React.PropsWithChildren<{ bodyClassName?: string; icon?: React.ReactNode; title: React.ReactNode; headerSlot?: React.ReactNode }>) {
    return (
        <div className='w-full flex flex-col text-white text-[12px]'>
            <div className='w-full h-[31px] flex justify-between items-center bg-midnight p-[8px]'>
                <div className='flex justify-between items-center'>
                    <div className='mr-[10px]'>{icon}</div>
                    {title}
                </div>
                {headerSlot && <div className='w-full'>{headerSlot}</div>}
            </div>
            <div className={bodyClassName}>{children}</div>
        </div>
    );
}
